import { makeStore } from "./makeStore";

const store = makeStore();

export default store;
